import { exportToExcel } from '../../../../../utils';
import { getPOGrandTotal } from '../../purchase-order/helper';
import { hasGrnExtraCharges } from './helper';

export const downloadReports = (data) => {
  if (!data.length) {
    return;
  }
  const anyExtraCharges = data.some((item) => hasGrnExtraCharges(item?.document));

  const results = data.map((item) => {
    const document = item?.document || {};
    const poId = document?.poId || {};
    const site = item.site

    return {
      'GRN NO': document?.grnNo || null,
      'PO Number': document?.poNumber || null,
      'Site Code': site?.code || null,
      'Site Name': site?.name || null,
      'Vendor Code': document?.vendorCode || null,
      'Vendor Name': poId?.vendorName || null,
      'Pending With': item?.pendingWith || null,
      'Total PO Value': getPOGrandTotal(poId),
      'Total Invoice Value': document?.hasOwnProperty?.('invoiceAmount')
        ? Math.round(document.invoiceAmount).toFixed(2)
        : null,
      ...(anyExtraCharges && {
        'GRN Extra Charges Amt': hasGrnExtraCharges(document)
          ? Number(document?.extraChargesTotal || 0).toFixed(2)
          : '-',
      }),
    };
  });
  exportToExcel(results, "pending_grn_actions");
};
